import { removeCookie } from "./cookie.js";

import store from "../../store/index";

export function isLogged() {
    const token = store.getters["userModule/getToken"];

    if(token) {
        return true;
    }

    return false;
}

export function logout() {
    if (process.env.VUE_APP_ENVIRONMENT_NAME === "local") {
        removeCookie("jwt_token", "/", process.env.VUE_APP_ROOT_URL);
    }
    localStorage.removeItem("user-token");
    localStorage.removeItem("user-info");
    localStorage.removeItem("yVal");
    store.commit("userModule/setToken", null);
    store.commit("userModule/setUser", null);
    store.commit("userModule/setPersonality", null);
    store.commit("userModule/setInsightTraits", null);
    store.commit("userModule/setGroups", null);
    store.commit("userModule/setComparison", null);
    store.commit("userModule/setCycle", null);
}